import "./ComponentStyles/Home.css";

function Home(props) {
  return (
    <div className="about-container">
      <h1>Welcome to UMBC IEEE</h1>
      <p>
        We are UMBC's student branch of the <b>Institute of Electrical and Electronics Engineers</b>.<br></br> 
        The world's largest professional association for the advancement of technology.
      </p>
    </div>
  );
}

export default Home;